import React from 'react';
import {
    Datagrid,
    TextField,
    SimpleShowLayout,
    ArrayField,
    ReferenceField,
    useRecordContext,
} from 'react-admin';
import { Box } from '@mui/material';
import { expandedRowDataGridSx } from '../styles/dataGridStyles';

export const OrderListShow = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <SimpleShowLayout record={record} sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
            <Box display="flex" flexWrap="wrap" flexGrow={12} sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                <ArrayField label="Order Details" source="OrderDetails">
                    <Datagrid
                        bulkActionButtons={false}
                        rowClick={false}
                        sx={expandedRowDataGridSx}
                    >
                        <TextField label="Release #" source="Release_Num"/>
                        <TextField label="Quantity" source="Quantity"/>
                        <ReferenceField label="Precision" source="PrecisionID" reference="precisions" sortable={false} link={false}>
                            <TextField source="Precision" />
                        </ReferenceField>
                        <ReferenceField label="Product" source="ProductID" reference="products" sortable={false} link={false}>
                            <TextField source="Product" />
                        </ReferenceField>
                        <ReferenceField label="Pickup Location" source="PickupLocationID" reference="pickuplocations" sortable={false} link={false}>
                            <TextField source="Pickup_Location" />
                        </ReferenceField>
                        <ReferenceField label="Delivery Location" source="DeliveryLocationID" reference="deliverylocations" sortable={false} link={false}>
                            <TextField source="Delivery_Location" />
                        </ReferenceField>
                    </Datagrid>
                </ArrayField>
            </Box>
        </SimpleShowLayout>
    );
};

export default OrderListShow;
